<template>
  <div class="main-body razor-up-grey">
      <div class="benefits container">
        <h2 data-aos="fade-up" data-aos-delay="0" data-aos-offset="0">{{ data.title }}</h2>
        <div class="benefits__list" :class="{'benefits__list--smaller' : isSmaller}, {'aus-em' : isAuEm}">

          <div class="benefits__item" :class="{'mobile-hidden' : item.hiddenMobile}" v-for="(item, i) in data.cards" data-aos="fade-up" :data-aos-delay="100 * i" data-aos-offset="100">
            <div class="benefits__item__inner">
              <div class="benefits__item__front">
                <div :class="'benefits__item__image'">
                  <span :class="item.color">
                    <img :src="require(`../assets/img/${item.image}`)" alt="">
                  </span>
                </div>
                <div class="benefits__item__content white">
                  <p class="flip-card-name" :class="{'small' : isAuEm}">{{ item.name }}</p>
                  <img src="../assets/img/icons/flip.svg" alt="" @click="flipCardOpen(i)">
                </div>
              </div>
              <div class="benefits__item__back white">
                <p>{{ item.text }}</p>
                <img src="../assets/img/icons/flip.svg" alt="" @click="flipCardClose(i)">
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="requirements container" v-if="!isAuEm">
        <div class="requirements__image">
          <img :src="require(`../assets/img/iPhones/${requirements.image}`)" alt="" data-aos="zoom-in" data-aos-delay="100" data-aos-offset="200" height="600" width="350">
        </div>
        <div class="requirements__content" data-aos="zoom-in" data-aos-delay="100" data-aos-offset="200">
          <h2>{{  requirements.title }}</h2>
          <div class="requirements__list">
            <ul>
              <li v-for="(item, i) in requirements.list"><span>{{ item.text }}</span></li>
            </ul>
          </div>

          <div id="more-info" @click="openTips"><p>{{ requirements.tips }}</p></div>

          <div id="more-info-info">
            <span id="more-info-close" @click="closeTips"></span>

            <div v-for="(item, i) in requirements.moreInfo">
              <p><strong v-html="item.title"></strong></p>
              <ul>
                <li v-for="(item, ii) in item.list" v-html="item.text"></li>
              </ul>
            </div>

          </div>

          <a :href="requirements.buttonURL" id="what-you-need-apply" @click="addDataLayer()"><div class="custom-button custom-button--orange">{{ requirements.buttonText }}</div></a>

        </div>
      </div>

      <div class="diaries container" v-if="!isAuEm">
        <h2 data-aos="zoom-in-down" data-aos-offset="200">{{  diaries.title }}</h2>

        <div class="block-in jet-vid" v-for="(item, i) in diaries.videos" data-aos="zoom-in-down" data-aos-duration="700" data-aos-delay="300" data-aos-offset="200">
            <iframe width="560" height="315" :src="item.id" title="YouTube video player" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>

      </div>
  </div>
</template>

<script>
import Content from "../data/content";
let lang = process.env.VUE_APP_LOCALITY;

export default {
  mounted() {
      window.addEventListener('scroll', () => this.fixTipPopup());
  },
  setup() {
    return {
      data: Content[lang].benefits,
      requirements: Content[lang].requirements,
      diaries: Content[lang].diaries,
      isSmaller: lang == 'ie_ie' ? true : false,
      isAuEm: lang == 'pl_en' ? true : false,
    };
  },
  methods: {
    async flipCardOpen(number) {
      let container = document.getElementsByClassName('benefits__item');
      container[number].classList.add('flip');
      let name = container[number].getElementsByClassName('flip-card-name');
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          "event": "faq_view",
          "component_type": "faq card",
          "component_name": name[0].textContent,
        });
    },
    async flipCardClose(number) {
      let container = document.getElementsByClassName('benefits__item');
      container[number].classList.remove('flip')
    },
    async openTips() {
      let toolTip = document.getElementById('more-info');
      let moreInfoInfo = document.getElementById('more-info-info');
      let bodyOverlay = document.getElementById('body-overlay');
      let content = document.getElementsByClassName('requirements__content');
      let body = document.getElementsByTagName('body');
      moreInfoInfo.classList.add('open');
      bodyOverlay.classList.add('open');
      content[0].classList.add('popup-open');
      body[0].classList.add('overlay-open');
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        "event": "toolTip_view",
        "component_type": "tool tip",
        "component_name": 'Tips to speed up your application',
      });
    },
    async closeTips() {
      let moreInfoInfo = document.getElementById('more-info-info');
      let bodyOverlay = document.getElementById('body-overlay');
      let body = document.getElementsByTagName('body');
      body[0].classList.remove('overlay-open');
      moreInfoInfo.classList.remove('open');
      bodyOverlay.classList.remove('open');
    },
    async addDataLayer() {
      window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            "event": "apply_submit",
            "component_type": "button",
            "component_name": "apply now",
            "component_location": "What you'll need section"
          });
    },
    fixTipPopup() {
      if (lang !== 'pl_en') {
        let content = document.getElementsByClassName('requirements__content');
        let moreInfo = document.getElementById('more-info');
        let rect = moreInfo.getBoundingClientRect();
        if (rect.top >= 0 && rect.left >= 0
            && rect.bottom <= (window.innerHeight || moreInfo.clientHeight)
            && rect.right <= (window.innerWidth || moreInfo.clientWidth)) {
              content[0].classList.add('popup-open');
        }
      }
    },
  }
};

</script>



<style>
/* Benefits */

.benefits {
  padding-bottom: 70px;
  border-bottom: 1px solid rgba(36, 46, 48, 0.10);
}

.benefits h2 {
  text-align: center;
  font-size: 34px;
  font-family: 'jet-extrabold';
  line-height: 120%;
  margin-bottom: 40px;
}

.benefits__list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.benefits__list.aus-em {
  justify-content: space-evenly;
}

.benefits__list--smaller {
  max-width: 660px;
  margin: 0 auto;
}

.benefits__list--smaller .benefits__item {
  width: calc(50% - 19px);
}

.benefits__item {
  width: calc(33.33% - 19px);
  display:  block;
  height: 145px;
  margin-bottom: 20px;
}

.benefits__item__front {
  display: flex;
  flex-wrap: wrap;
}

.benefits__item__inner {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.8s;
  transform-style: preserve-3d;
}

.benefits__item__image {
  border-radius: 20px 0 0 20px;
  width: 45%;
  position: relative;
}

.benefits__item__image span {
  border-radius: 20px 0 0 20px;
  display: block;
  height: 100%;
  widtH: 100%;
}

.benefits__item__image img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 100%;
  height: auto;
  width: auto;
  max-width: 100%;
}
.benefits__item__content {
  border-radius: 0 20px 20px 0;
  padding: 20px;
  widtH: 55%;
}
.benefits__item__content img, .benefits__item__back img {
  position: absolute;
  bottom: 20px;
  right: 20px;
  cursor: pointer;
  transition: all 0.25s ease-in-out;
}
.benefits__item__content img:hover, .benefits__item__back img:hover {
  transform: rotate(90deg)
}
.benefits__item__content p {
  font-size: 20px;
  font-family: 'jet-extrabold';
  line-height: 24px;
}
.benefits__item__content p.small {
  font-size: 18px;
}
.benefits__item__back {
  border-radius: 20px;
  padding: 20px;
}

.benefits__item.flip .benefits__item__inner {
  transform: rotateY(180deg);
}

.benefits__item__front, .benefits__item__back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden; /* Safari */
  backface-visibility: hidden;
}

.benefits__item__back {
  background: white;
}

.benefits__item__back p {
  margin-right: 35px;
  font-size: 16px;
  line-height: 140%;
}

.benefits__item__back p.small {
  font-size: 14px;
}

.benefits__item__back {
  transform: rotateY(180deg);
}

@media only screen and (max-width: 1024px) {
  .benefits__item__content img, .benefits__item__back img {
    max-height: 36px;
    max-width: 36px;
  }
  .benefits__item__content p {
    font-size: 16px;
  }
}

@media only screen and (max-width: 768px) {
  .benefits.container {
    padding: 40px 18px 0;
  }
  .benefits__item {
    width: 100%;
    height: 126px;
    max-widtH: 400px;
    margin: 0 auto 20px;
  }
  .benefits__item.mobile-hidden {
    display: none;
  }
  .benefits h2 {
    font-size: 26px;
  }
  .benefits__item__image img {
    object-fit: contain;
    object-position: center;
    height: 100%;
    widtH: 100%;
  }

  .benefits__list--smaller .benefits__item {
    width: 100%;
  }

}

/* Requirements */

.requirements {
  display: flex;
  flex-wrap: wrap;
  padding: 60px 0 60px;
  border-bottom: 1px solid rgba(36, 46, 48, 0.10);
}

.requirements__image, .requirements__content {
  width: 50%;
}

.requirements__content h2 {
  font-size: 34px;
  font-weight: 800;
  margin-bottom: 30px;
}

.requirements__content.popup-open {
  transform: none !important;
}


.requirements__image img {
  max-width: 350px;
}

.requirements__list {
  border-radius: 20px;
  padding: 15px 17px 15px 60px;
}

.requirements__list p {
  margin-bottom: 0;
  font-size: 16px;
}
.requirements__list ul {
  margin-left: -17px;
  max-widtH: 265px;
}

.requirements__list li {
  font-size: 16px;
  line-height: 130%;
  font-family: 'jet-bold';
  /* list-style-image: url('../img/icons/tick.svg'); */
  list-style-type: none;
  margin-bottom: 20px;
}

.requirements__list li span {
  margin-left: 17px;
  display: block;
  position: relative;
}

.requirements__list li span::before {
  content: '';
  display: block;
  background-image: url('../assets/img/icons/tick.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 25px;
  width: 25px;
  position: absolute;
  top: -3px;
  left: -45px;

}

.requirements #more-info {
  background: white;
  border-radius: 20px;
  padding: 13px 35px;
  max-width: 392px;
  margin-bottom: 25px;
  cursor: pointer;
  /* display: none; */
}

.requirements #more-info:hover p {
  color: #ff8000;
}

.requirements #more-info p {
  font-size: 16px;
  line-height: 160%;
  text-decoration: underline;
  font-family: 'jet-bold';
  position: relative;
  margin-left: 26px;
  max-width: 246px;
  margin-bottom: 0;
  transition: all 0.25s ease-in-out;
}

.requirements #more-info-info {
  display: block;
  background: white;
  padding: 45px 30px;
  border-radius: 20px;
  position: fixed;
  z-index: 999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: none;
  max-widtH: 604px;
}
.requirements #more-info-info p {
  font-family: 'jet-bold';
  margin-bottom: 0;
}
.requirements #more-info-info p span {
  visibility: hidden;
}
.requirements #more-info-info ul {
  margin-bottom: 48px;
}
.requirements #more-info-info div:last-of-type ul {
  margin-bottom: 0;
}
.requirements #more-info-info li {
  font-size: 16px;
  line-height: 150%;
  margin-bottom: 0;
  margin-left: 9px;
}
.requirements #more-info-info img {
  margin: 0 auto 5px;
  max-width: 100px;
}

.requirements #more-info-info.open {
  display: block;
}

.requirements #more-info-close {
  background: url('../assets/img/icons/close-black.svg');
  height: 17px;
  width: 17px;
  display: block;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  top: 24px;
  right: 27px;
  cursor: pointer;
}

.requirements #more-info.open {

}

.requirements #more-info-info.open {
  max-height: 100%;
  margin-bottom: 16px;
}

.requirements #more-info p::before {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  left: -43px;
  background-image: url('../assets/img/icons/info.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  height: 24px;
  width: 24px;
  transform: translateY(-50%);
  transition: all 0.2s ease-in-out;
}

.requirements #more-info:hover p::before {
  background-image: url('../assets/img/icons/info-orange.svg');
}

@media only screen and (max-width: 768px) {

  .requirements.container {
    padding: 47px 18px 0;
  }

  .requirements__image, .requirements__content {
    width: 100%;
  }

  .requirements__image {
    order: 2;
    text-align: center;
  }

  .requirements__image img {
    max-widtH: 400px;
    margin-bottom: -200px;
    width: 100%;
  }

  .requirements__content {
    order: 1;
  }

  .requirements h2 {
    font-size: 26px;
    line-height: 120%;
    text-align: center;
  }

  .requirements a {
    display: none;
  }

  .requirements__list ul {
    margin: 0 auto;
  }

  .requirements__list li {
    font-size: 14px;
    line-height: 160%;
  }

  .requirements li a {
    display: inline-block;
  }

  .requirements #more-info {
    display: block;
    margin: 0 auto 15px;
  }

  .requirements #more-info p {
    font-size: 14px;
  }

  .requirements #more-info-info {
    top: 25%;
    left: 16px;
    right: 16px;
    transform: translate(0 ,0);
    padding: 40px 27px 120px;
    bottom: 0;
    overflow: scroll;
  }
  .requirements #more-info-info li, .requirements #more-info-info p {
    font-size: 14px;
  }
  .requirements__list p {
    font-size: 14px;
  }
}

.diaries {
  padding: 70px 0 0;
  position: relative;
  margin-bottom: -100px !important;
}

.diaries h2 {
  font-size: 34px;
  line-height: 120%;
  font-family: 'jet-extrabold';
  text-align: center;
  max-width: 587px;
  margin: 0 auto 40px;
}

.diaries img {
  border-radius: 30px;
  border: 2px solid rgba(36, 46, 48, 0.10);
}

.diaries .block-in {
  position: relative;
  display: block;
  padding-bottom: 56.25%;
}

.diaries .block-in iframe {
  position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 30px;
}

@media only screen and (max-width: 768px) {
  .diaries.container {
    padding: 70px 18px;
  }
  .diaries h2 {
    font-size: 26px;
  }
}

</style>
